import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { OnboardingPageService } from '../../onboarding-page/onboarding-page.service';
import { ToastMessage } from '../../toast-message/toast-message.service';

@Component({
  selector: 'app-fleet-manager-onboarding',
  template: require('./fleet-manager-onboarding.component.html'),
  providers: [OnboardingPageService]
})
export class FleetManagerOnboardingComponent {

  public overHeadPanelTitle = 'Fleet Manager Onboarding - Start';

  public mobile: string;
  public loading = false;

  mobileFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern('^[6-9][0-9]{9}$')
  ]);

  constructor(
    private router: Router,
    private onboardingService: OnboardingPageService,
    private toast: ToastMessage
  ) {}

  isFormValid() {
    return this.mobileFormControl.valid;
  }

  async start() {
    if (!this.isFormValid()) { return; }
    this.loading = true;
        try {
      // API1 (Entities): fetch user by mobile to determine userId
      let fmUserId = '';
      try {
        const entityResp: any = await this.onboardingService.getUserByMobileViaBff(this.mobile).toPromise();
        fmUserId = entityResp && entityResp.data && entityResp.data._id ? entityResp.data._id : '';
      } catch (_e) {
        fmUserId = '';
      }

      // captain-service lookup using found userId (if available)
      const resp: any = await this.onboardingService.fetchFleetManagerByMobile(fmUserId || (localStorage.getItem('userId') || ''), this.mobile).toPromise();
      if (resp && resp.data && resp.data._id) {
        // Prepopulate via query params
        const fm = resp.data;
        const type = (fm.type === 'thirdParty' ? 'third_party' : fm.type) || '';
        const cityId = fm.city || '';
        const fleetId = fm.fleetId || '';
        const name = fm.name || '';
        const profilePicLink = fm.profilePicture && fm.profilePicture.link ? fm.profilePicture.link : '';
        this.router.navigate(['/fleetManagerOnboardingDetails'], {
          queryParams: { mobile: this.mobile, name, cityId, fleetId, fleetType: type, userId: fm.userId || fmUserId || '', profilePicLink }
        });
      } else {
        // Navigate with just mobile if not found
        this.router.navigate(['/fleetManagerOnboardingDetails'], { queryParams: { mobile: this.mobile, userId: fmUserId || '' } });
      }
    } catch (e) {
      this.router.navigate(['/fleetManagerOnboardingDetails'], { queryParams: { mobile: this.mobile } });
    } finally {
      this.loading = false;
    }
  }

  goBack() {
    this.router.navigate(['/onboardFleet']);
  }
}


